import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=5676705d&"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js&"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetForm.vue?vue&type=style&index=0&id=5676705d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports